import $ from 'jquery';

$(function () {
    $('.mobile-dropdown .tab-change').on('click', function (evt) {
        evt.preventDefault();
        const $block = $(this).parents('.block.tabs');
        const $button = $block.find('.dropdown');
        const $pane = $block.find('.dropdown-pane');
        const $tabsContent = $block.find('.tabs-content');

        $button.text($(this).text());
        $tabsContent.find('.tabs-panel').removeClass('is-active');
        $($(this).attr('href')).addClass('is-active');
        $pane.foundation('close');

    });

    $('.mobile-dropdown .tab-change').on('click', function (evt) {
        evt.preventDefault();
        window.location = $(this).attr('href');
    });
});